import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Paper } from "@mui/material";

export const AdvCard = styled(Paper)(({ theme }) => ({
  width: 370,
  height: 250,
  border: "1px solid #c9c1ff",
  borderRadius: "10px",
  textOverflow: "ellipsis",
  overflowY: "clip",
}));

export const AdvDesc = styled.p`
  font-size: 0.895rem;
  line-height: 1.25rem;
  padding: 1rem;
  font-weight: 500;
`;

export const AdvTitle = styled.h4`
  padding-left: 1rem;
  font-style: bold;
  display: flex;
`;
